import enGB from 'date-fns/locale/en-GB'
import es from 'date-fns/locale/es'
import pt from 'date-fns/locale/pt'

import { i18n } from '@flecto/translations'

const languageMap: { [key: string]: Locale } = {
  pt,
  es,
  en: enGB,
}

export function useDateLanguage() {
  return languageMap[i18n.language] || pt
}
